import { useCallback } from 'react'
import { useRouter } from 'next/router'

import Boutton from '@piconetworks/pkg-boutton'
import Picon from '@piconetworks/pkg-picon'

import styles from './BackButton.module.scss'

const BackButton = () => {
    const { push } = useRouter()
    const onClick = useCallback(() => {
        push('/settings/integrations')
    }, [push])

    return (
        <Boutton
            className={styles.backButton}
            onClick={onClick}
            variant="link"
            icon={<Picon icon="arrow-left" color="#834eff" />}
        >
            Back
        </Boutton>
    )
}

export default BackButton
